module.exports = __webpack_public_path__ + "static/img/pad11.ea00e0c1.png";